var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isInsideIFrame } from './utils/iframe';
import { NodeSmartLinkProvider } from './lib/NodeSmartLinkProvider';
import { createStorage } from './utils/storage';
import { IFrameCommunicator } from './lib/IFrameCommunicator';
import { IFrameMessageType } from './lib/IFrameCommunicatorTypes';
import { QueryParamPresenceWatcher } from './lib/QueryParamPresenceWatcher';
import { defineAllRequiredWebComponents } from './web-components/components';
import { ConfigurationManager } from './lib/ConfigurationManager';
import { NotInitializedError } from './utils/errors';
import { Logger, LogLevel } from './lib/Logger';
class KontentSmartLinkSDK {
    constructor(configuration) {
        this.initialize = () => __awaiter(this, void 0, void 0, function* () {
            yield defineAllRequiredWebComponents();
            const level = this.configurationManager.debug ? LogLevel.Debug : LogLevel.Info;
            Logger.setLogLevel(level);
            if (this.configurationManager.queryParam) {
                this.queryParamPresenceWatcher.watch(this.configurationManager.queryParam, this.nodeSmartLinkProvider.toggle);
            }
            else {
                this.nodeSmartLinkProvider.enable();
            }
            if (isInsideIFrame()) {
                this.initializeIFrameCommunication();
            }
        });
        this.destroy = () => {
            this.queryParamPresenceWatcher.unwatchAll();
            this.iframeCommunicator.destroy();
            this.nodeSmartLinkProvider.destroy();
        };
        this.updateConfiguration = (configuration) => {
            if (typeof configuration.queryParam !== 'undefined') {
                if (!configuration.queryParam) {
                    this.nodeSmartLinkProvider.enable();
                }
                else if (configuration.queryParam !== this.configurationManager.queryParam) {
                    this.queryParamPresenceWatcher.unwatchAll();
                    this.queryParamPresenceWatcher.watch(configuration.queryParam, this.nodeSmartLinkProvider.toggle);
                }
            }
            if (typeof configuration.debug !== 'undefined') {
                const level = configuration.debug ? LogLevel.Debug : LogLevel.Info;
                Logger.setLogLevel(level);
            }
            this.configurationManager.update(configuration);
        };
        this.initializeIFrameCommunication = () => {
            var _a, _b;
            this.iframeCommunicator.initialize();
            const storage = createStorage('kontent-smart-link:iframe-settings');
            const stored = storage.get();
            const enabled = stored !== null ? stored === null || stored === void 0 ? void 0 : stored.enabled : true;
            const messageData = {
                projectId: (_a = this.configurationManager.defaultProjectId) !== null && _a !== void 0 ? _a : null,
                languageCodename: (_b = this.configurationManager.defaultLanguageCodename) !== null && _b !== void 0 ? _b : null,
                enabled,
            };
            this.iframeCommunicator.sendMessageWithResponse(IFrameMessageType.Initialized, messageData, () => {
                this.configurationManager.update({ isInsideWebSpotlight: true });
                this.queryParamPresenceWatcher.unwatchAll();
                this.nodeSmartLinkProvider.disable();
                if (enabled) {
                    this.nodeSmartLinkProvider.enable();
                }
                this.iframeCommunicator.addMessageListener(IFrameMessageType.Status, (data) => {
                    if (!data || !this.nodeSmartLinkProvider)
                        return;
                    this.nodeSmartLinkProvider.toggle(data.enabled);
                    storage.set({
                        enabled: data.enabled,
                    });
                });
            });
        };
        this.configurationManager = ConfigurationManager.getInstance();
        this.configurationManager.update(configuration);
        this.queryParamPresenceWatcher = new QueryParamPresenceWatcher();
        this.iframeCommunicator = new IFrameCommunicator();
        this.nodeSmartLinkProvider = new NodeSmartLinkProvider(this.iframeCommunicator);
        this.initialize();
    }
}
class KontentSmartLink {
    constructor() {
        this.sdk = null;
        this.destroy = () => {
            var _a;
            (_a = this.sdk) === null || _a === void 0 ? void 0 : _a.destroy();
            this.sdk = null;
        };
        this.setConfiguration = (configuration) => {
            if (!this.sdk) {
                throw NotInitializedError('KontentSmartLink is not initialized or has already been destroyed.');
            }
            else {
                this.sdk.updateConfiguration(configuration);
            }
        };
    }
    static initializeOnLoad(configuration) {
        return new Promise((resolve) => {
            window.addEventListener('load', () => {
                resolve(KontentSmartLink.initialize(configuration));
            });
        });
    }
    static initialize(configuration) {
        if (!KontentSmartLink.instance) {
            KontentSmartLink.instance = new KontentSmartLink();
        }
        if (!KontentSmartLink.instance.sdk) {
            KontentSmartLink.instance.sdk = new KontentSmartLinkSDK(configuration);
        }
        return KontentSmartLink.instance;
    }
}
export default KontentSmartLink;
//# sourceMappingURL=sdk.js.map